import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("BentoItemWidget", {
  title: "BentoItem",
  properties: ["wideStyle", "tallStyle", "boxStyle", "target"],
});
